export const filterPriorizationOptions = [
  {
    'key': '',
    'value': '',
    'text': 'TODO',
  },
  {
    'key': 'prioritized',
    'value': 'prioritized',
    'text': 'PRIORIZADOS',
  },
  {
    'key': 'notPrioritized',
    'value': 'notPrioritized',
    'text': 'NO PRIORIZADOS',
  },
];

export const filterPriorizationVehTypeOptions = [
  {
    'key': '',
    'value': '',
    'text': 'TODO',
  },
  {
    'key': 'normal',
    'value': 'normal',
    'text': 'NORMALES',
  },
  {
    'key': 'specials',
    'value': 'specials',
    'text': 'ESPECIALES',
  },
];

export const ordersMapper = {
  'TODO': {
    'key': '',
    'value': '',
    'text': 'TODO',
  },
  'MOV': {
    'key': 'MOV',
    'value': 'MOV',
    'text': 'MOVILIZACIÓN',
  },
  'HU': {
    'key': 'HU',
    'value': 'HU',
    'text': 'HUNTER',
  },
  'ACC': {
    'key': 'ACC',
    'value': 'ACC',
    'text': 'ACCESORIOS',
  },
  'PDS': {
    'key': 'PDS',
    'value': 'PDS',
    'text': 'PDS',
  },
};
